import PropTypes from 'prop-types';
import React, { useContext } from 'react';

import ApplicationContext from '../ApplicationContext';
import IfmsButton, { IfmsButtonProps } from './IfmsButton';
import EditIcon2 from '../img/Edit2.svg';
import EditIcon2_D from '../img/Edit_Dark2.svg'
import EditIcon3 from '../img/toolbar-edit-light.svg';
import EditIcon3_D from '../img/toolbar-edit-dark.svg'
import EditIcon4 from '../img/edit_light.svg';
import EditIcon4_D from '../img/Edit_Dark.svg';
import EditIcon4_DA from '../img/edit_dark_accent.svg';
import EditIcon5 from '../img/edit-light.svg';
import EditIcon5_D from '../img/edit-dark.svg';
import EditIcon5_DA from '../img/edit-dark-accent.svg';
import ViewIcon3 from '../img/View3.svg'
import ViewIcon3_D from '../img/View3_Dark.svg';
import ViewIcon4 from '../img/toolbar-view-light.svg'
import ViewIcon4_D from '../img/toolbar-view-dark.svg';
import ViewIcon5 from '../img/view_light.svg'
import ViewIcon5_D from '../img/View_Dark.svg';
import ViewIcon5_DA from '../img/view_dark_accent.svg';
import ViewIcon6 from '../img/view-light.svg'
import ViewIcon6_D from '../img/view-dark.svg';
import ViewIcon6_DA from '../img/view-dark-accent.svg';
import DeleteIcon2 from '../img/Trash_Light.svg';
import DeleteIcon2_D from '../img/Trash_Dark.svg';
import DeleteIcon3 from '../img/toolbar-delete-light.svg';
import DeleteIcon3_D from '../img/toolbar-delete-dark.svg';
import DeleteIcon4 from '../img/delete_light.svg';
import DeleteIcon4_D from '../img/Delete_Dark.svg';
import DeleteIcon4_DA from '../img/delete_dark_accent.svg';
import PrintIcon2 from '../img/Print01_2.svg';
import PrintIcon2_D from '../img/Print01_Dark2.svg';
import AddIcon2 from '../img/Add2.svg';
import AddIcon2_D from '../img/Add_Dark2.svg';
import AddIcon3 from '../img/toolbar-new-light.svg';
import AddIcon3_D from '../img/toolbar-new-dark.svg';
import AddIcon4 from '../img/new_light.svg';
import AddIcon4_D from '../img/new_dark.svg';
import AddIcon4_DA from '../img/new_dark_accent.svg';
import AddIcon5 from '../img/new-light.svg';
import AddIcon5_D from '../img/new-dark.svg';
import AddIcon5_DA from '../img/new-dark-accent.svg';

import BalIcon2 from '../img/Balance2.svg';
import BalIcon2_D from '../img/Balance_Dark2.svg';
import BillingsIcon2 from '../img/billing-overall2.svg';
import BillingsIcon2_D from '../img/billing-overall_Dark2.svg';
import RefreshIcon from '../img/toolbar-refresh-light.svg';
import RefreshIcon_D from '../img/toolbar-refresh-dark.svg';
import RefreshIcon2 from '../img/refresh_light.svg';
import RefreshIcon2_D from '../img/refresh_dark.svg';
import RefreshIcon2_DA from '../img/refresh_dark_accent.svg';

import ViewHistoryIcon2 from '../img/ViewHistory2.svg';
import ViewHistoryIcon2_D from '../img/ViewHistory_Dark2.svg';
import DeleteHistoryIcon2 from '../img/DeleteHistory2.svg';
import DeleteHistoryIcon2_D from '../img/DeleteHistory_Dark2.svg';
import PrimaryButton from './PrimaryButton';
import { FmsSecTask } from '../fms.core/constants';
import { SecType } from '../fms.enum';
import { getSecBySecTask } from '../util';

const IconButton = React.forwardRef<HTMLButtonElement, IfmsButtonProps>(({ children, useText, isActive, ...other }, ref) => {
  let notsetbackcolorwhendisabled = other.notsetbackcolorwhendisabled === 'true' ? true : false;
  let baseClass = !notsetbackcolorwhendisabled ? 'ifms-icon-button' : 'ifms-icon-button b';
  if (isActive) baseClass = 'ifms-memo-button';
  const appContext = useContext(ApplicationContext);
  const isType2 = appContext.suntekSettings?.company?.billingsTabVersion === 2;
  
  //const showIconButton = !isType2 || !useText;
  const showIconButton = !useText;
  
  return (
    showIconButton ?
      <IfmsButton ref={ref} {...other} baseClass={baseClass} size="imgStyle">
        {children}
      </IfmsButton>
      :
      <PrimaryButton {...other} icon={''} size="extrasmall" data-tooltip='' >
        {other['data-tooltip']}
      </PrimaryButton>
  );
});

IconButton.defaultProps = {
  notsetbackcolorwhendisabled: 'false',
  isActive: false,
  useText: false
};

IconButton.propTypes = {
  size: PropTypes.oneOf(['regular', 'small', 'large', 'imgStyle']),
  notsetbackcolorwhendisabled: PropTypes.string,
  isActive: PropTypes.bool,
  useText: PropTypes.bool,
  iconMode: PropTypes.bool,
};

export default React.memo(IconButton);

interface IconButtonProps {
  onClick: (x: any) => void;
  disabled?: boolean;
  id?: string;
  name?: string;
  tooltip?: string;
  preventDuplicateAction?: boolean;
  iconMode?: boolean;
  [x: string]: any;
}

const centerAlignStyle: React.CSSProperties = {
  alignItems: 'center',
  justifyContent: 'center',
  gap: '4px',
  margin: '0px 3px 0px 3px',
};

const centerAlignStyle2: React.CSSProperties = {
  alignItems: 'center',
  justifyContent: 'center',
};


//New
export const AddIconButton: React.FC<IconButtonProps> = ({ onClick, disabled, name, id, style, useText, iconMode, ...other }) => {
  const appContext = useContext(ApplicationContext);
  const isDarkMode = appContext.useDarkMode;

  const buttonStyle = iconMode ? {
    margin: '0 10px 0 3px',
    ...style
  } : style;

  return (
      <IconButton
        data-tooltip='New'
        id={id ?? 'list-New-button'}
        name={name ?? 'list-New-button'}
        disabled={disabled}
        onClick={onClick}
        icon={isDarkMode ? AddIcon2_D : AddIcon2}
        style={buttonStyle}
        {...other}
      />
  );
};



//New
export const AddIconButton2: React.FC<IconButtonProps> = ({ onClick, disabled, name, id, style, useText, iconMode, ...other }) => {
  const appContext = useContext(ApplicationContext);
  const isDarkMode = appContext.useDarkMode;

  const buttonStyle = iconMode ? {
    //margin: '0 10px 0 3px',
    alignItems: 'center',
    justifyContent: 'center',
    ...style
  } : style;

  return (
      <IconButton
        data-tooltip='New'
        id={id ?? 'list-New-button'}
        name={name ?? 'list-New-button'}
        disabled={disabled}
        onClick={onClick}
        icon={isDarkMode ? AddIcon5_D : AddIcon5}
        style={buttonStyle}
        {...other}
        iconHeight="24px"
      />
  );
};

//New(Dark Mode Accent)
export const AddIconButton3: React.FC<IconButtonProps> = ({ onClick, disabled, name, id, style, useText, iconMode, ...other }) => {
  const appContext = useContext(ApplicationContext);
  const isDarkMode = appContext.useDarkMode;

  const buttonStyle = {
    //margin: '0 10px 0 3px',
    alignItems: 'center',
    justifyContent: 'center',
    ...style
  };

  return (
      <IconButton
        data-tooltip='New'
        id={id ?? 'list-New-button'}
        name={name ?? 'list-New-button'}
        disabled={disabled}
        onClick={onClick}
        icon={isDarkMode ? AddIcon5_DA : AddIcon5}
        style={buttonStyle}
        {...other}
        iconHeight="24px"
      />
  );
};



//EditButton
export const EditIconButton: React.FC<IconButtonProps> = ({ onClick, disabled, name, tooltip, id, useText, ...other }) => {
  const appContext = useContext(ApplicationContext);
  const isDarkMode = appContext.useDarkMode;

  return (
      <IconButton
        data-tooltip={tooltip ?? 'Edit'}
        id={id ?? 'list-edit-button'}
        name={name ?? 'list-edit-button'}
        disabled={disabled}
        onClick={onClick}
        icon={isDarkMode ? EditIcon2_D : EditIcon2}
        style={{margin: '0px 3px 0px 3px',}}
        {...other}
      />
  );
}


//EditButton2
export const EditIconButton2: React.FC<IconButtonProps> = ({ onClick, disabled, name, tooltip, id, useText, ...other }) => {
  const appContext = useContext(ApplicationContext);
  const isDarkMode = appContext.useDarkMode;

  return (
      <IconButton
        data-tooltip={tooltip ?? 'Edit'}
        id={id ?? 'list-edit-button'}
        name={name ?? 'list-edit-button'}
        disabled={disabled}
        onClick={onClick}
        icon={isDarkMode ? EditIcon5_D : EditIcon5}
        style={centerAlignStyle2}
        {...other}
        iconHeight="24px"
      />
  );
}

//Edit(Dark Mode Accent)
export const EditIconButton3: React.FC<IconButtonProps> = ({ onClick, disabled, name, tooltip, id, useText, ...other }) => {
  const appContext = useContext(ApplicationContext);
  const isDarkMode = appContext.useDarkMode;

  return (
      <IconButton
        data-tooltip={tooltip ?? 'Edit'}
        id={id ?? 'list-edit-button'}
        name={name ?? 'list-edit-button'}
        disabled={disabled}
        onClick={onClick}
        icon={isDarkMode ? EditIcon5_DA : EditIcon5}
        style={centerAlignStyle2}
        {...other}
        iconHeight="24px"
      />
  );
}


//View
export const ViewIconButton: React.FC<IconButtonProps> = ({ onClick, disabled, name, id, useText, ...other }) => {
  const appContext = useContext(ApplicationContext);
  const isDarkMode = appContext.useDarkMode;

  return (
      <IconButton
        data-tooltip='View'
        id={id ?? 'list-view-button'}
        name={name ?? 'list-view-button'}
        disabled={disabled}
        onClick={onClick}
        icon={isDarkMode ? ViewIcon3_D: ViewIcon3}
        style={{ ...centerAlignStyle }}
        {...other}
      />
  );
}

//View
export const ViewIconButton2: React.FC<IconButtonProps> = ({ onClick, disabled, name, id, useText, ...other }) => {
  const appContext = useContext(ApplicationContext);
  const isDarkMode = appContext.useDarkMode;

  return (
      <IconButton
        data-tooltip='View'
        id={id ?? 'list-view-button'}
        name={name ?? 'list-view-button'}
        disabled={disabled}
        onClick={onClick}
        icon={isDarkMode ? ViewIcon6_D: ViewIcon6}
        style={{ ...centerAlignStyle2 }}
        {...other}
        iconHeight="24px"
      />
  );
}

//View(Dark Mode Accent)
export const ViewIconButton3: React.FC<IconButtonProps> = ({ onClick, disabled, name, id, useText, ...other }) => {
  const appContext = useContext(ApplicationContext);
  const isDarkMode = appContext.useDarkMode;

  return (
      <IconButton
        data-tooltip='View'
        id={id ?? 'list-view-button'}
        name={name ?? 'list-view-button'}
        disabled={disabled}
        onClick={onClick}
        icon={isDarkMode ? ViewIcon6_DA: ViewIcon6}
        style={{ ...centerAlignStyle2 }}
        {...other}
        iconHeight="24px"
      />
  );
}

//Delete
export const DeleteIconButton: React.FC<IconButtonProps> = ({ onClick, disabled, name, id, useText, ...other }) => {
  const appContext = useContext(ApplicationContext);
  const isDarkMode = appContext.useDarkMode;

  return (
      <IconButton
        data-tooltip='Delete'
        id={id ?? 'list-delete-button'}
        name={name ?? 'list-delete-button'}
        disabled={disabled}
        onClick={onClick}
        icon={isDarkMode ? DeleteIcon2_D : DeleteIcon2}
        {...other}
        style={{margin: '0px 3px 0px 3px'}}
      />
  );
}


export const DeleteIconButton2: React.FC<IconButtonProps> = ({ onClick, disabled, name, id, useText, ...other }) => {
  const appContext = useContext(ApplicationContext);
  const isDarkMode = appContext.useDarkMode;

  return (
      <IconButton
        data-tooltip='Delete'
        id={id ?? 'list-delete-button'}
        name={name ?? 'list-delete-button'}
        disabled={disabled}
        onClick={onClick}
        icon={isDarkMode ? DeleteIcon4_D : DeleteIcon4}
        style={{ ...centerAlignStyle2 }}
        {...other}
        iconHeight="24px"
      />
  );
}

//Delete(Dark Mode Accent)
export const DeleteIconButton3: React.FC<IconButtonProps> = ({ onClick, disabled, name, id, useText, ...other }) => {
  const appContext = useContext(ApplicationContext);
  const isDarkMode = appContext.useDarkMode;

  return (
      <IconButton
        data-tooltip='Delete'
        id={id ?? 'list-delete-button'}
        name={name ?? 'list-delete-button'}
        disabled={disabled}
        onClick={onClick}
        icon={isDarkMode ? DeleteIcon4_DA : DeleteIcon4}
        style={{ ...centerAlignStyle2 }}
        {...other}
        iconHeight="24px"
      />
  );
}


//Print
export const PrintIconButton: React.FC<IconButtonProps> = ({ onClick, disabled, name, tooltip, id, useText, ...other }) => {
  const appContext = useContext(ApplicationContext);
  const isDarkMode = appContext.useDarkMode;
  const isType2 = appContext.suntekSettings?.company?.billingsTabVersion === 2;

  return (
    //isType2 && useText ?
      <PrimaryButton id={id ?? 'list-print-button'} name={name ?? 'list-print-button'} disabled={disabled} size="extrasmall" onClick={onClick} {...other} data-tooltip=''>Print</PrimaryButton>
      // :
      // <IconButton
      //   data-tooltip={tooltip ?? 'Print'}
      //   id={id ?? 'list-print-button'}
      //   name={name ?? 'list-print-button'}
      //   disabled={disabled}
      //   onClick={onClick}
      //   icon={isDarkMode ? PrintIcon2_D : PrintIcon2}
      //   {...other}
      // />
  );
}

//Balance
export const BalanceIconButton: React.FC<IconButtonProps> = ({ onClick, disabled, name, id, useText, ...other }) => {
  const appContext = useContext(ApplicationContext);
  const hasSecBal = getSecBySecTask(appContext, FmsSecTask.ListBalance, SecType.Read);
  const isDarkMode = appContext.useDarkMode;
  const isType2 = appContext.suntekSettings?.company?.billingsTabVersion === 2;

  if (!hasSecBal) return <></>;

  return (
    //isType2 && useText ?
      <PrimaryButton id={id ?? 'list-balance-button'} name={name ?? 'list-balance-button'} disabled={disabled} size="extrasmall" onClick={onClick} {...other} data-tooltip=''>Balance</PrimaryButton>
      // :
      // <IconButton
      //   data-tooltip='Balance'
      //   id={id ?? 'list-balance-button'}
      //   name={name ?? 'list-balance-button'}
      //   disabled={disabled}
      //   onClick={onClick}
      //   icon={isDarkMode ? BalIcon2_D : BalIcon2}
      //   {...other}
      // />
  );
}
//Journal
export const JournalIconButton: React.FC<IconButtonProps> = ({ onClick, disabled, name, id, useText, ...other }) => {
  return (
    // isType2 && useText ?
    //   <PrimaryButton id={id ?? 'list-journal-button'} name={name ?? 'list-journal-button'} disabled={disabled} size="extrasmall" onClick={onClick} {...other} data-tooltip=''>Journal</PrimaryButton>
    //   :
    //   <IconButton
    //     data-tooltip='Journal'
    //     id={id ?? 'list-journal-button'}
    //     name={name ?? 'list-journal-button'}
    //     disabled={disabled}
    //     onClick={onClick}
    //     icon={isDarkMode ? JournalIcon_D : JournalIcon}
    //     {...other}
    //   />
    <PrimaryButton id={id ?? 'list-journal-button'} name={name ?? 'list-journal-button'} disabled={disabled} size="extrasmall" onClick={onClick} {...other} data-tooltip=''>Journal</PrimaryButton>
  );
}
//Billings
export const BillingsIconButton: React.FC<IconButtonProps> = ({ onClick, disabled, name, id, useText, ...other }) => {
  const appContext = useContext(ApplicationContext);
  const isDarkMode = appContext.useDarkMode;
  const isType2 = appContext.suntekSettings?.company?.billingsTabVersion === 2;

  return (
   // isType2 && useText ?
      <PrimaryButton id={id ?? 'list-billings-button'} name={name ?? 'list-billings-button'} disabled={disabled} size="extrasmall" onClick={onClick} {...other} data-tooltip=''>Billings</PrimaryButton>
      // :
      // <IconButton
      //   data-tooltip='Billings'
      //   id={id ?? 'list-billings-button'}
      //   name={name ?? 'list-billings-button'}
      //   disabled={disabled}
      //   onClick={onClick}
      //   icon={isDarkMode ? BillingsIcon2_D : BillingsIcon2}
      //   {...other}
      // />
  );
}
//View history
export const ViewHistoryIconButton: React.FC<IconButtonProps> = ({ onClick, disabled, name, id, useText, ...other }) => {
  const appContext = useContext(ApplicationContext);
  const isDarkMode = appContext.useDarkMode;
  const isType2 = appContext.suntekSettings?.company?.billingsTabVersion === 2;

  return (
    //isType2 && useText ?
      <PrimaryButton id={id ?? 'list-viewHistory-button'} name={name ?? 'list-viewHistory-button'} disabled={disabled} size="extrasmall" onClick={onClick} {...other} data-tooltip=''>View History</PrimaryButton>
      //:
      // <IconButton
      //   data-tooltip='View History'
      //   id={id ?? 'list-viewHistory-button'}
      //   name={name ?? 'list-viewHistory-button'}
      //   disabled={disabled}
      //   onClick={onClick}
      //   icon={isDarkMode ? ViewHistoryIcon2_D : ViewHistoryIcon2}
      //   {...other}
      // />
  );
}
//Delete history
export const DeleteHistoryIconButton: React.FC<IconButtonProps> = ({ onClick, disabled, name, id, useText, ...other }) => {
  const appContext = useContext(ApplicationContext);
  const isDarkMode = appContext.useDarkMode;
  const isType2 = appContext.suntekSettings?.company?.billingsTabVersion === 2;
  const delHistoryLabel = <>Del&nbsp;&nbsp;History</>;

  return (
   // isType2 && useText ?
      <PrimaryButton id={id ?? 'list-deleteHistory-button'} name={name ?? 'list-deleteHistory-button'} disabled={disabled} size="extrasmall" onClick={onClick} {...other} data-tooltip=''>{delHistoryLabel}</PrimaryButton>
      // :
      // <IconButton
      //   data-tooltip='Delete History'
      //   id={id ?? 'list-deleteHistory-button'}
      //   name={name ?? 'list-deleteHistory-button'}
      //   disabled={disabled}
      //   onClick={onClick}
      //   icon={isDarkMode ? DeleteHistoryIcon2_D : DeleteHistoryIcon2}
      //   {...other}
      // />
  );
}
//Recog history
export const RecogHistoryIconButton: React.FC<IconButtonProps> = ({ onClick, disabled, name, id, useText, ...other }) => {
  const appContext = useContext(ApplicationContext);
  const recogHistoryLabel = <>Recog&nbsp;&nbsp;History</>;

  return (
    <PrimaryButton id={id ?? 'list-recogHistory-button'} name={name ?? 'list-recogHistory-button'} disabled={disabled} size="extrasmall" onClick={onClick} {...other} data-tooltip=''>{recogHistoryLabel}</PrimaryButton>
  );
}
//Save
export const SaveIconButton: React.FC<IconButtonProps> = ({ onClick, disabled, name, tooltip, preventDuplicateAction, id, ...other }) => {
  const appContext = useContext(ApplicationContext);
  const isType2 = appContext.suntekSettings?.company?.billingsTabVersion === 2;

  function renderLabelWithHotkey(tooltip?: string) {
    const label = tooltip ?? 'Save';

    if (label.toLowerCase() === 'save') {
      return (
        <>
          <span style={{ textDecoration: 'underline' }}>S</span>ave
        </>
      );
    }

    return label;
  }

  return (
    isType2 ?
      <PrimaryButton id={id ?? 'list-save-button'} name={name ?? 'list-save-button'} disabled={disabled} size="extrasmall" onClick={onClick} {...other} data-tooltip=''> {renderLabelWithHotkey(tooltip)}</PrimaryButton>
      :
      <PrimaryButton
        size='extrasmall'
        id={id ?? 'list-save-button'}
        name={name ?? 'list-save-button'}
        disabled={disabled}
        onClick={onClick}
        preventDuplicateAction={preventDuplicateAction}
        {...other}
      > {renderLabelWithHotkey(tooltip)}</PrimaryButton>
  );
}

//Save&Continue
export const SaveContinueIconButton: React.FC<IconButtonProps> = ({ onClick, disabled, name, id, ...other }) => {
  const appContext = useContext(ApplicationContext);
  const isType2 = appContext.suntekSettings?.company?.billingsTabVersion === 2;
  return (
    isType2 ?
      <PrimaryButton id={id ?? 'list-saveContinue-button'} name={name ?? 'list-saveContinue-button'} disabled={disabled} size="extrasmall" onClick={onClick} {...other} data-tooltip=''>Save & Stay</PrimaryButton>
      :
      <PrimaryButton
        size='extrasmall'
        id={id ?? 'list-saveContinue-button'}
        name={name ?? 'list-saveContinue-button'}
        disabled={disabled}
        onClick={onClick}
        {...other}
      >Save & Stay</PrimaryButton>
  );
}

//Run Query
export const RunQueryIconButton: React.FC<IconButtonProps> = ({ onClick, disabled, name, id, ...other }) => {
  const appContext = useContext(ApplicationContext);
  const isDarkMode = appContext.useDarkMode;
  const isType2 = appContext.suntekSettings?.company?.billingsTabVersion === 2;
  return (
    <PrimaryButton id={id ?? 'list-runQuery-button'} name={name ?? 'list-runQuery-button'} disabled={disabled} size="extrasmall" onClick={onClick} {...other} data-tooltip=''>Run Query</PrimaryButton>
  );
}

//Refresh Icon
export const RefreshIconButton: React.FC<IconButtonProps> = ({ onClick, disabled, name, id, tooltip, ...other }) => {
  const appContext = useContext(ApplicationContext);
  const isDarkMode = appContext.useDarkMode;

  return (
      <IconButton
         data-tooltip={tooltip ?? 'Refresh'}
        id={id ?? 'list-screen-refresh'}
        name={name ?? 'list-screen-refresh'}
        disabled={disabled}
        onClick={onClick}
        icon={isDarkMode ? RefreshIcon2_D: RefreshIcon2}
        style={{ ...centerAlignStyle2 }}
        {...other}
        iconHeight="24px"
      />
  );
}

//Refresh Icon(Dark Mode Accent)
export const RefreshIconButton2: React.FC<IconButtonProps> = ({ onClick, disabled, name, id, tooltip, ...other }) => {
  const appContext = useContext(ApplicationContext);
  const isDarkMode = appContext.useDarkMode;

  return (
      <IconButton
         data-tooltip={tooltip ?? 'Refresh'}
        id={id ?? 'list-screen-refresh'}
        name={name ?? 'list-screen-refresh'}
        disabled={disabled}
        onClick={onClick}
        icon={isDarkMode ? RefreshIcon2_DA: RefreshIcon2}
        style={{ ...centerAlignStyle2 }}
        {...other}
        iconHeight="24px"
      />
  );
}